import { CissAutoComplete, CissAutoCompleteProps } from 'components/autocompletes/CissAutoComplete';

export type ReembolsoStatusApuracao = {
    cdApuracaoLojaNotaWrapperSituacao: number;
    dsApuracaoLojaNotaWrapperSituacao: string;
};

export function ConsultaReembolsoStatusAutoComplete({
    sx,
    name,
    value,
    error,
    options,
    readOnly,
    disableClearable,
    multiple = false,
    disabled = false,
    onChange = () => {},
    requestOptions = {
        url: '/financeiro/apuracaolojanotawrappersituacao',
        sort: [{ property: 'cdApuracaoLojaNotaWrapperSituacao', direction: 'ASC' }],
        nested: true,
        limit: 50,
    },
}: CissAutoCompleteProps) {
    return (
        <CissAutoComplete
            sx={sx}
            name={name}
            value={value}
            error={error}
            options={options}
            multiple={multiple}
            onChange={onChange}
            disabled={disabled}
            readOnly={readOnly}
            disableClearable={disableClearable}
            size="small"
            label="Status"
            objectId="cdApuracaoLojaNotaWrapperSituacao"
            optionStringTemplate="{dsApuracaoLojaNotaWrapperSituacao}"
            selectedStringTemplate="{dsApuracaoLojaNotaWrapperSituacao}"
            isOptionEqualToValue={(option: ReembolsoStatusApuracao, value: ReembolsoStatusApuracao) =>
                value && option && option.cdApuracaoLojaNotaWrapperSituacao === value.cdApuracaoLojaNotaWrapperSituacao
            }
            requestOptions={requestOptions}
        />
    );
}
